<div *ngIf=" assets && !assets.name">
  <div class="asset" *ngIf="assets && assets.assetTypeName else noAssetsFound" #asset>
    <div class="asset-content">
      <p class="asset-name">
        <span>{{assets.assetTypeName || assets.name}}</span>
      </p>
      <p class="asset-description">{{assets.modelName}}</p>
      <p class="asset-modal">{{assets.assetCode}}</p>
    </div>
    <div
      class="asset-image"
    >
      <img
        src="{{ assets.assetTypeIconUrl }}"
        alt="asset-icon"
        height="80"
        onerror="this.onerror=null; this.src='assets/144x144/asset-default.svg';"
      />
    </div>
  </div>
</div>

<!-- workspace assets -->
<!-- asset-types -->
<div *ngIf=" assets && !assets.assetTypeName">
  <div class="asset" *ngIf="assets && assets.name else noAssetsTypeFound" #asset>
    <div class="asset-content">
      <p class="asset-name">
        <span>{{assets.name}}</span>
      </p>
      <p class="asset-description">{{assets.properties.length }} Properties</p>
    </div>
    <div class="asset-image">
      <img
        src="{{ assets.iconUrl }}"
        alt="asset-icon"
        height="80"
        onerror="this.onerror=null; this.src='assets/144x144/asset-default.svg';"
      />

    </div>
  </div>
</div>

<!-- accessory type -->

<div
  *ngIf=" accessory && accessory.name
"
>
  <div
    class="asset"
    *ngIf="accessory && accessory.name else noAccessoryTypeFound"
    #asset
  >
    <div class="asset-content">
      <p class="asset-name">
        <span>{{accessory.name}}</span>
      </p>
      <p class="asset-description">
        {{accessory.properties.length }} Properties
      </p>
    </div>
    <div class="asset-image" *ngIf="accessory.name.substring(0,3)!=='Eko'">
      <img
        src="{{ accessory.iconUrl }}"
        alt="accessory-icon"
        height="80"
        onerror="this.onerror=null; this.src='assets/144x144/accessory-default.svg';"
      />
    </div>
  </div>
</div>
<ng-template #noAssetsFound>
  <div class="asset no-asset">
    <div class="asset-content">
      <p class="asset-name">No assets assigned</p>
      <p class="asset-description">Generate ticket to request an asset</p>
    </div>
  </div>
</ng-template>

<ng-template #noAssetsTypeFound>
  <div class="asset no-asset">
    <div class="asset-content">
      <p class="asset-name">No assets assigned</p>
      <p class="asset-description">Generate ticket to request an asset</p>
    </div>
  </div>
</ng-template>

<ng-template #noAccessoryTypeFound>
  <div class="asset no-asset">
    <div class="asset-content">
      <p class="asset-name">No accessory assigned</p>
      <p class="asset-description">Generate ticket to request an accessory</p>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="plan">
  <div class="plan-cards" >
        <section class="card-title">
            <h4 class="title">{{plan.name??'Title'}}</h4>
            <button class="edit-btn" (click)="handleEdit(plan)">
              <img src="assets/14x14/edit_blue.svg" alt=""> 
              <span class="btn-txt">Edit Plan</span>
            </button>
        </section>
        <div class="data">
            <div class="data-item">
                <img src="assets/16x16/tick.svg" alt="" class="tick-img">
                <p>{{plan.workspaceOwnerLimit}} Workspace Owners</p>
            </div>
            <div class="data-item">
                <img src="assets/16x16/tick.svg" alt="" class="tick-img">
                <p>{{plan.adminLimit}} IT Admins</p>
            </div>
            <div class="data-item">
                <img src="assets/16x16/tick.svg" alt="" class="tick-img">
                <p>{{plan.userLimit}} End Users</p>
            </div>
            <div class="data-item">
                <img src="assets/16x16/tick.svg" alt="" class="tick-img">
                <p>{{plan.assetLimit}} Assets</p>
            </div>
        </div>
        <div class="data">
            <p>Plan Duration <br><span class="bold-text">{{ getTenure(plan.tenure) }}</span></p>
            <p>Plan Fee <br><span class="bold-text">{{plan.price | currency:'INR'}}</span></p>
        </div>
    </div>
</ng-container>